<template>
  <svg width="100%" height="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_28438_39352)">
      <path
          d="M15.5748 4.43368C15.2298 4.08859 14.6723 4.08859 14.3272 4.43368L10.0003 8.75172L5.67344 4.42483C5.32835 4.07974 4.7709 4.07974 4.42581 4.42483C4.08072 4.76992 4.08072 5.32737 4.42581 5.67246L8.7527 9.99935L4.42581 14.3262C4.08072 14.6713 4.08072 15.2288 4.42581 15.5739C4.7709 15.919 5.32835 15.919 5.67344 15.5739L10.0003 11.247L14.3272 15.5739C14.6723 15.919 15.2298 15.919 15.5748 15.5739C15.9199 15.2288 15.9199 14.6713 15.5748 14.3262L11.248 9.99935L15.5748 5.67246C15.9111 5.33622 15.9111 4.76992 15.5748 4.43368Z"
          fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_28438_39352">
        <rect width="20" height="20" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>